import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import QueryString from 'qs';
import { toast } from 'react-toastify';
import moment from 'moment';
import { ClipLoader } from 'react-spinners';

import PageWithCard from '../../components/infrastructure/PageWithCard';
import { authAxiosInstance } from '../../utils/axiosConfig';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';
import PaginationClassic from '../../components/pagination/PaginationClassic';
import messageLogo from '../../images/messenger.png';
import telephoneLogo from '../../images/telephone.png';
import telephoneLogo2 from '../../images/telephone2.png';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import { MessageSquare, PhoneIncoming, PhoneOutgoing } from 'react-feather';
import TableAndSearchCustom from '../../components/Table/TableAndSearchCustom';

const PhoneBook = () => {
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [phonebook, setPhonebook] = useState({});
    console.log('phonebook', phonebook);
    const [linkOption, setLinkOption] = useState({});
    const [openMessageBox, setOpenMessageBox] = useState(false);
    const [scrollY, setScrollY] = useState(0);

    const dispatch = useDispatch();

    const fetchPhonebook = async (search = '') => {
        try {
            setLoading(true);
            const payload = {
                page,
                occurredDate: {
                    $gte: moment().subtract(2, 'days').startOf('day').valueOf(),
                    $lte: moment().endOf('day').valueOf(),
                },
            };
            if (search || search !== '') {
                payload['search'] = search;
            }
            console.log('fetch payload', payload);
            const string = QueryString.stringify(payload);
            const resp = await authAxiosInstance.get(`/phonebook?${string}`);
            console.log('resp', resp);
            setPhonebook(resp?.data?.data);
        } catch (error) {
            console.log('Error', error);
            toast.error('Failed to fetch phonebook data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPhonebook();
    }, [page]);

    useEffect(() => {
        const handelScroll = () => {
            setScrollY(window.scrollY);
        };
        window.addEventListener('scroll', handelScroll);

        return () => {
            window.removeEventListener('scroll', handelScroll);
        };
    }, []);

    const replacePlaceholder = (inputStr, replacementArray) => {
        let replacedStr = inputStr;
        for (let i = 0; i < replacementArray.length; i++) {
            replacedStr = replacedStr.replace('{#var#}', replacementArray[i]);
        }
        return replacedStr;
    };

    const debouncedSearch = useCallback(
        _.debounce(async (search) => {
            fetchPhonebook(search);
        }, 300),
        []
    );

    const groupByDate = (data) => {
        const grouped = data?.reduce((acc, ele) => {
            const occurredMoment = moment(
                ele.occurredAt,
                'MMMM D, YYYY [at] hh:mma'
            );
            const isToday = occurredMoment.isSame(moment(), 'day');
            const isYesterday = occurredMoment.isSame(
                moment().subtract(1, 'days'),
                'day'
            );
            const groupTitle = isToday
                ? 'Today'
                : isYesterday
                  ? 'Yesterday'
                  : occurredMoment.format('DD/MM/YYYY');

            if (!acc[groupTitle]) {
                acc[groupTitle] = [];
            }
            acc[groupTitle].push(ele);

            return acc;
        }, {});

        return Object.entries(grouped);
    };
    const calculateCallStatus = (status, time, phoneNumber) => {
        if (status === 'missed' && time === 0) {
            return (
                <PhoneIncoming
                    className='cursor-pointer'
                    color="#E71010"
                    style={{ fill: '#E71010' }}
                    size={20}
                    onClick={async(e)=>{
                        e.stopPropagation();
                        try {
                            const resp = await authAxiosInstance.post(
                                `/vendors/directPushCall`,
                                { phoneNumber : phoneNumber.slice(-10) }
                            )
                            console.log('resp call',resp)
                            if(resp?.data?.success){
                                toast.success('Call Placed')
                            }
                            
                        } catch (error) {
                            console.log('Error',error);
                            toast.error('Failed to call this number')
                        }
                    }}
                />
            );
        } else if (status === 'outgoing' && time === 0) {
            return (
                <img src={telephoneLogo} alt="telephone" className="w-[24px] cursor-pointer" 
                onClick={async(e)=>{
                    e.stopPropagation();
                    try {
                        const resp = await authAxiosInstance.post(
                            `/vendors/directPushCall`,
                            { phoneNumber : phoneNumber }
                        )
                        console.log('resp call',resp)
                        if(resp?.data?.success){
                            toast.success('Call Placed')
                        }
                        
                    } catch (error) {
                        console.log('Error',error);
                        toast.error('Failed to call this number')
                    }
                }}
                />
            );
        } else if (status === 'outgoing' && time > 0) {
            return (
                <img
                    src={telephoneLogo2}
                    alt="telephone2"
                    className="w-[24px] cursor-pointer"
                    onClick={async(e)=>{
                        e.stopPropagation();
                        try {
                            const resp = await authAxiosInstance.post(
                                `/vendors/directPushCall`,
                                { phoneNumber : phoneNumber }
                            )
                            console.log('resp call',resp)
                            if(resp?.data?.success){
                                toast.success('Call Placed')
                            }
                            
                        } catch (error) {
                            console.log('Error',error);
                            toast.error('Failed to call this number')
                        }
                    }}
                />
            );
        } else {
            return (
                <PhoneIncoming
                    color="#347D2F"
                    style={{ fill: '#347D2F' }}
                    size={20}
                    className='cursor-pointer'
                    onClick={async(e)=>{
                        e.stopPropagation();
                        try {
                            const resp = await authAxiosInstance.post(
                                `/vendors/directPushCall`,
                                { phoneNumber : phoneNumber }
                            )
                            console.log('resp call',resp)
                            if(resp?.data?.success){
                                toast.success('Call Placed')
                            }
                            
                        } catch (error) {
                            console.log('Error',error);
                            toast.error('Failed to call this number')
                        }
                    }}
                />
            );
        }
    };

    const cols = [
        {
            Header: 'Name',
            accessor: 'name',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-col">
                        <span>{row?.original?.phone}</span>
                        <span className="text-[11px]">
                            {row?.original?.name}
                        </span>
                    </div>
                );
            },
            cellStye: {
                width: '60%',
            },
        },
        // {
        //     Header: 'Phone No.',
        //     accessor: 'phone',
        // },
        {
            Header: 'Time',
            accessor: 'occurredAt',
            Cell: ({ row }) => {
                const occurredMoment = moment(
                    row.original.occurredAt,
                    'MMMM D, YYYY [at] h:mma'
                );
                const date = occurredMoment.format('DD-MM');
                const time = occurredMoment.format('HH:mm');
                return (
                    <div className="flex flex-col">
                        {/* <span>{date}</span> */}
                        <span>{time}</span>
                        <span className="hidden">
                            {row?.original?.occurredAt}
                        </span>
                    </div>
                );
            },
            cellStye: {
                width: '15%',
            },
        },
        {
            Header: 'Type',
            accessor: 'callStatus',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-col">
                        <span>
                            {calculateCallStatus(
                                row?.original?.callStatus,
                                row?.original?.callDuration,
                                row?.original?.phone
                            )}
                        </span>
                        <span className="hidden">
                            {row?.original?.callStatus}
                        </span>
                    </div>
                );
            },
            cellStye: {
                width: '10%',
            },
        },
        // {
        //     Header: 'Duration',
        //     accessor: 'callDuration',
        // },
        {
            Header: ' ',
            Cell: ({ row }) => {
                return (
                    <span
                        className="cursor-pointer"
                        onClick={async (e) => {
                            e.stopPropagation();
                            const obj = {
                                phone: row?.original?.phone,
                            };
                            const respData = await authAxiosInstance.post(
                                `/api/ifttt/manualText`,
                                obj
                            );
                            console.log('respData', respData);
                            if (respData?.data?.success) {
                                toast.success(`${respData?.data?.message}`);
                            }
                        }}
                    >
                        {/* <img
                            src={messageLogo}
                            alt="messageLogo"
                            className="w-[25px] h-[25px]"
                        /> */}
                        <MessageSquare color="#3F51B5" />
                    </span>
                );
            },
            cellStye: {
                width: '15%',
            },
        },
    ];

    const phonebookData = useMemo(() => {
        if (phonebook && phonebook?.docs?.length) {
            return groupByDate(phonebook?.docs);
        } else return [];
    }, [phonebook]);
    console.log('phoneBook data==>>>', phonebookData);
    return (
        // <PageWithCard heading="Phonebook">
        //     <TableWithHeadingAndGlobalSearch
        //         columns={cols}
        //         data={phonebookData}
        //         loading={loading}
        //         searchFunction={debouncedSearch}
        //     />
        //     <PaginationClassic
        //         paginationDetails={phonebook}
        //         setPage={setPage}
        //     />
        // </PageWithCard>
        <div className="p-4 w-full md:w-1/2 text-center m-auto ">
            <h1 className="text-center text-xl font-semibold mb-4">Samsung</h1>
            {loading ? (
                <ClipLoader />
            ) : (
                phonebookData.map(([dateTitle, values]) => (
                    <div className="" key={dateTitle}>
                        <div className="sticky top-[63px] bg-gray-200 text-gray-500 text-sm px-1 mx-auto z-60 text-center w-[30%] md:w-[15%] rounded-lg">
                            {dateTitle}
                        </div>
                        <TableAndSearchCustom
                            columns={cols}
                            data={values}
                            loading={false}
                            searchFunction={debouncedSearch}
                            className={`rounded-xl`}
                        />
                    </div>
                ))
            )}
            {/* <TableWithHeadingAndGlobalSearch
                columns={cols}
                data={phonebookData}
                loading={loading}
                searchFunction={debouncedSearch}
            /> */}
            <PaginationClassic
                paginationDetails={phonebook}
                setPage={setPage}
            />
        </div>
    );
};

export default PhoneBook;
